import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { anonymousClient, phoneNumberClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
    plugins: [anonymousClient(), phoneNumberClient(), oauthProviderClient()],
});
